import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { fDateTimeDate } from "src/utils/formatTime";
import { DialogAnimate } from "src/components/Animate";
import { useTranslation } from "react-i18next";
import Markdown from "src/components/Markdown";

const MarkdownWrapperStyle = styled("div")(({ theme }) => ({
  "& > p": {
    ...theme.typography.body1,
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginright: theme.spacing(2),
  },
}));

const DialogStyle = styled(DialogAnimate)(({ theme }) => ({
  "& .MuiDialog-paper": {
    margin: 0,
    [theme.breakpoints.up("md")]: {
      maxWidth: "calc(90% - 48px)",
      maxHeight: "calc(85% - 48px)",
    },
  },
  ".css-ji9w9w-MuiDialog-paper.MuiDialog-paperFullScreen": {
    "border-radius": 15,
  },
}));

export default function NotificationPreview({
  open,
  onClose,
  notification,
  markAsRead,
}) {
  const { t } = useTranslation();

  return (
    <DialogStyle open={open} onClose={() => onClose()} fullWidth maxWidth="xl">
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h4">{notification?.title}</Typography>
          {fDateTimeDate(notification?.creationDate)}
        </Stack>

        <Typography variant="h6">{notification?.description}</Typography>
      </DialogTitle>

      <DialogContent>
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <MarkdownWrapperStyle>
              <Markdown children={notification?.content} />
            </MarkdownWrapperStyle>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            if (notification?.isUnRead) markAsRead(notification.Id);
            else onClose();
          }}
        >
          <Typography variant="h5">
            {notification?.isUnRead
              ? t("tucarta.MarkAsReaded")
              : t("tucarta.Exit")}
          </Typography>
        </Button>
      </DialogActions>
    </DialogStyle>
  );
}
